import { ReactNode, useState } from 'react';

import { Box, Icon } from '@core/component';
import { EColor, EIcon, ESize } from '@core/type';
import { ModalWhatIsVatFreeStorage } from '@core/widget';

export const BadgeWhatIsVatFreeStorage = ({ children }: { children: ReactNode }) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  return (
    <>
      <Box
        display={'flex'}
        gap={'4px'}
        role={'button'}
        onClick={(e) => {
          e.preventDefault();
          setIsOpen(true);
        }}
      >
        {children}
        <Icon type={EIcon.INFO} color={EColor.INFO} size={ESize.XXS} />
      </Box>
      <ModalWhatIsVatFreeStorage isOpen={isOpen} onCloseModal={() => setIsOpen(false)} />
    </>
  );
};
